import { createContext } from 'react';

const GroupContext = createContext({
    expanded: false,
    provider: '',
});

export default GroupContext;
